import type { BackendVault } from '@/types'

export function isVaultInNetworks(vault: BackendVault, networks: string[]): boolean {
  if (networks.length === 0) return true
  return networks.includes(vault.network)
}
